// Stub: Matilda's canned demo responses. Chat is disabled so no demo replies
// are ever surfaced — this is here only to satisfy the import.

export function getRandomDemoResponse(_kind: string): string {
  return '';
}
